import React, { useEffect } from "react";

export default function Gradient({ children }: any) {
  useEffect(() => {}, []);

  return (
    <div className="gradient">
      <div className="gradient__content">{children}</div>
    </div>
  );
}
